import * as $ from 'jquery';
export const MobileFilterTrigger = () =>{
	$('.js-mobile-filter-trigger').on('click',function(){
		$('.products-filter').toggle(500);
		$(this).toggleClass("opened");
	});
}
